import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "aircraft",
  "number",
  "title",
  "type",
  "programme",
  "interval",
  "last_done",
  "next_due",
  "due",
  "in",
  "remaining",
  "man_hours",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const AIRCRAFT_COLUMNS = COLUMNS.filter(
  (column) => column !== "aircraft",
)

export const FIXED_COLUMNS: Column[] = ["number", "title"]

export const COLUMN_LABELS: Record<Column, string> = {
  aircraft: "Aircraft",
  number: "Task no.",
  title: "Description",
  type: "Type",
  programme: "Program",
  interval: "Interval",
  last_done: "Last complied",
  next_due: "Next due at",
  due: "Due",
  in: "In",
  remaining: "Remaining",
  man_hours: "Man-hrs",
}

export type Slot = Column | "select" | "actions"

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "forecast-due",
  widths: {
    select: 2.25,
    aircraft: 5.5,
    number: 9.5,
    title: 14,
    type: 3.5,
    programme: 11,
    interval: 8,
    last_done: 10,
    next_due: 7,
    due: 7,
    in: 5.5,
    remaining: 6.5,
    man_hours: 5,
    actions: 3.25,
  },
  fill: "title",
  pinned: ["select", "actions"],
  extras: [],
  dropOrder: [
    "type",
    "programme",
    "man_hours",
    "interval",
    "in",
    "remaining",
    "next_due",
    "last_done",
  ],
}

export function withFixed(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => FIXED_COLUMNS.includes(column) || columns.includes(column),
  )
}

export const SELECTABLE_SIZING: ColumnSizing<Slot> = {
  ...COLUMN_SIZING,
  extras: ["select", "actions"],
}

export function slotsOf(columns: Column[]): Slot[] {
  return ["select", ...columns, "actions"]
}
